<template>
  <button class="button" @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'Button'
  }
</script>

<style scoped>
  .button {
    border-radius: 4px;
    padding: 8px 12px;
    background: var(--accent);
    color: #fff;
    font-weight: 700;
    border: none;
    display: block;
    width: 100%;
    box-sizing: border-box;
    font-size: 12px;
  }

  .button:hover, .button:active {
    background: #111;
  }
</style>
